import React, { useEffect } from "react";

import { useProductServiceApi } from "@api/hooks/productService.hook";
import {
    ProductTileMapper,
    ProductsMapper,
} from "@api/mappers/products.mapper";

import { ProductFieldSet } from "@utils/enums";

import { Spinner } from "@components/General/Spinner/spinner.component";

import Calculation from "./calculation/calculation.component";
import {
    ConfigurationSkuList,
    useCorrugatedSheetCalculation,
} from "./corrugatedSheetCalculation";
import Result from "./result/result.component";
import { CorrugatedSheetShoppingListComponent } from "./shoppinglist/corrugatedSheet.shoppingList.component";

const CorrugatedSheetCalculator = () => {
    const {
        setHeight,
        setLength,
        setWidth,
        setProductLine,
        setIsTwoSidedRoof,
        setColor,
        setProductData,
        toggleAcc,
        height,
        length,
        width,
        productLine,
        isTwoSidedRoof,
        result,
        hasValidResult,
        color,
        activeAcc,
    } = useCorrugatedSheetCalculation();

    const [{ data, loading }, getProducts] = useProductServiceApi(
        {
            params: {
                sku: ConfigurationSkuList.join(","),
                fields: ProductFieldSet.ProductTile,
            },
            url: `/products`,
            method: "GET",
            mapper: ProductsMapper(ProductTileMapper),
        },
        { autoCancel: false, manual: true, useCache: false },
    );

    useEffect(() => {
        getProducts();
    }, []);

    useEffect(() => {
        setProductData(data || []);
    }, [data]);

    return (
        <div id="calculator">
            {loading && <Spinner color="primary" />}
            {!loading && (
                <>
                    <Calculation
                        setHeight={setHeight}
                        setLength={setLength}
                        setWidth={setWidth}
                        setProductLine={setProductLine}
                        setIsTwoSidedRoof={setIsTwoSidedRoof}
                        setColor={setColor}
                        height={height}
                        length={length}
                        width={width}
                        productLine={productLine}
                        isTwoSidedRoof={isTwoSidedRoof}
                        color={color}
                    />
                    {hasValidResult && (
                        <>
                            <Result
                                result={result}
                                mailParams={{
                                    roofHeight: height,
                                    roofWidth: width,
                                    rootLength: length,
                                    productLine,
                                    isTwoSidedRoof: isTwoSidedRoof.toString(),
                                    color: color?.toString() || "",
                                }}
                            />
                            <CorrugatedSheetShoppingListComponent
                                result={result}
                                toggleAcc={toggleAcc}
                                activeAcc={activeAcc}
                            />
                        </>
                    )}
                </>
            )}
        </div>
    );
};

export { CorrugatedSheetCalculator };
